import "./PasswordReset.scss";
import React, { useContext, useEffect, useState } from "react";
import { Box, Card, Container, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import LoadingButton from "@mui/lab/LoadingButton";
import { GlobalContext } from "../../context/Provider";
import { reseteoContrasena } from "../../services/LoginService";
import { useParams } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PasswordReset = () => {
  const [errorMessage, setErrorMessage] = useState("");

  const [showForm, setShowForm] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [values, setValues] = React.useState({
    showPassword: false,
    showRePassword: false,
  });

  const navigate = useNavigate();

  const { token } = useParams();

  const {
    authDispatch,
    authState: {
      auth: { loading, error, data },
    },
  } = useContext(GlobalContext);

  /* useEffect(() => {
    if (data) {
      navigate("/home");
    }
  }, [data]); */

  const handleClickGoToLogin = () => {
    navigate("/");
  };

  const handleClickRegister = () => {
    navigate("/register");
  };

  const handleClickLoginDoctor = () => {
    navigate("/");
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleClickShowRePassword = () => {
    setValues({
      ...values,
      showRePassword: !values.showRePassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownRePassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = (data) => {

    reseteoContrasena(token, data.password)
      .then((response) => {
        if (response.status === "Ok") {
          setShowForm(!showForm);
          setShowConfirmation(!showConfirmation);
        } else {
          setErrorMessage(response.errors.join());
        }
        console.log("Respuesta de reseteoContrasena:", response);
      })
      .catch((error) => {
        console.error("Error en reseteoContrasena:", error);
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
      .required("El campo contraseña es requerido")
      .min(10, "La contraseña debe tener al menos 8 caracteres")
      .max(20, "La contraseña no debe exceder los 20 caracteres")
      .test(
        "lowercase-test",
        "La contraseña debe contener al menos 2 letras minúsculas",
        value => /(?=(.*[a-zñüáéíóú]){2,})/.test(value)
      )
      .test(
        "uppercase-test",
        "La contraseña debe contener al menos 2 letras mayúsculas",
        value => /(?=(.*[A-ZÑÜÁÉÍÓÚ]){2,})/.test(value)
      )
      .test(
        "number-test",
        "La contraseña debe contener al menos 2 números",
        value => /(?=(.*\d){2,})/.test(value)
      )
      .test(
        "special-character-test",
        "La contraseña debe contener al menos 2 caracteres especiales",
        value => /(?=(.*[@$!%*?&'`.]){2,})/.test(value)
      ),
      repassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir")
        .required("Confirme su contraseña"),
    }),
    onSubmit: (data) => onSubmit(data),
  });
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        marginTop: 20,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ padding: "20px" }}>
          {/* Show Form */}
          {showForm && (
            <form onSubmit={formik.handleSubmit}>
              <Box sx={{ my: 1 }}>
                <Typography
                  color="textPrimary"
                  align="center"
                  variant="h4"
                >
                  Reseteo de contraseña
                </Typography>
                {error && (
                  <Typography
                    align="center"
                    sx={{
                      fontSize: "0.84rem",
                      lineHeight: "1.5rem",
                      fontWeight: "300",
                      color: "red",
                    }}
                  >
                    {error}
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  pb: 1,
                  pt: 1,
                }}
              >
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                >
                  Complete la nueva contraseña y su validación
                </Typography>
              </Box>

              {/* <TextField
              fullWidth
              label="Email"
              margin="normal"
              name="email"
              error={Boolean(formik.touched.email && formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.email}
              type="email"
              variant="outlined"
            /> */}

              <TextField
                fullWidth
                label="Contraseña"
                margin="normal"
                name="password"
                type={values.showPassword ? "text" : "password"}
                variant="outlined"
                autoComplete="new-password"
                error={Boolean(
                  formik.touched.password && formik.errors.password
                )}
                helperText={formik.touched.password && formik.errors.password}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.password}
                /* onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.password}
                error={Boolean(form2Touched.password && form2Errors.password)}
                helperText={form2Touched.password && form2Errors.password} */
                sx={{ my: 1 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                label="Verificación de contraseña"
                margin="normal"
                name="repassword"
                type={values.showRePassword ? "text" : "password"}
                variant="outlined"
                error={Boolean(
                  formik.touched.repassword && formik.errors.repassword
                )}
                helperText={
                  formik.touched.repassword && formik.errors.repassword
                }
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.repassword}
                /* onChange={handleForm2Change}
                onBlur={handleForm2Blur}
                value={form2Values.repassword}
                error={Boolean(
                  form2Touched.repassword && form2Errors.repassword
                )}
                helperText={form2Touched.repassword && form2Errors.repassword} */
                sx={{ my: 1 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowRePassword}
                        onMouseDown={handleMouseDownRePassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {errorMessage && (
                <Typography
                  sx={{
                    fontSize: "1rem",
                    fontWeight: "400",
                    textAlign: "center",
                    color: "red",
                  }}
                >
                  {errorMessage}
                </Typography>
              )}

              <Box sx={{ mt: 2 }}>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  Resetear contraseña
                </LoadingButton>
              </Box>
              <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
                <a
                  href="/password-reset"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClickLoginDoctor();
                  }}
                  className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                  style={{ marginBottom: "8px", textDecoration: "none" }}
                >
                  Ingreso a la plataforma
                </a>
              </Box>
              {/* <Box sx={{ mt: 0, display: "flex", justifyContent: "flex-end" }}>
                <a
                  href="/register"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClickRegister();
                  }}
                  className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
                  style={{ textDecoration: "none" }}
                >
                  Registro
                </a>
              </Box> */}
            </form>
          )}

          {/* Show Confirmation */}
          {showConfirmation && (
            <form>
              <Box sx={{ my: 1 }}>
                <Typography
                  color="textPrimary"
                  align="center"
                  variant="h4"
                >
                  Reseteo de contraseña
                </Typography>
              </Box>
              <Box
                sx={{
                  pb: 1,
                  pt: 1,
                }}
              >
                <Typography
                  align="center"
                  color="textSecondary"
                  variant="body1"
                >
                  Su contraseña fue reseteada con éxito.
                </Typography>
              </Box>
              <Box sx={{ mt: 2 }}>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  fullWidth
                  size="large"
                  type="button"
                  variant="contained"
                  onClick={handleClickGoToLogin}
                >
                  Ir al Ingreso
                </LoadingButton>
              </Box>
            </form>
          )}
        </Card>
      </Container>
    </Box>
  );
};

export default PasswordReset;
